import { render, staticRenderFns } from "./HelloHome.vue?vue&type=template&id=8ed89260"
import script from "./HelloHome.vue?vue&type=script&lang=js"
export * from "./HelloHome.vue?vue&type=script&lang=js"
import style0 from "./HelloHome.vue?vue&type=style&index=0&id=8ed89260&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports